const digitsRegex = /^[\d\s]+$/;

export default {
  digitsRegex
};
